/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MobileDevice
 */
export interface MobileDevice {
    /**
     * 
     * @type {string}
     * @memberof MobileDevice
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof MobileDevice
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileDevice
     */
    deviceId: string;
    /**
     * 
     * @type {Date}
     * @memberof MobileDevice
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof MobileDevice
     */
    client?: number;
}

export function MobileDeviceFromJSON(json: any): MobileDevice {
    return MobileDeviceFromJSONTyped(json, false);
}

export function MobileDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobileDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'deviceId': json['device_id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'client': !exists(json, 'client') ? undefined : json['client'],
    };
}

export function MobileDeviceToJSON(value?: MobileDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'device_id': value.deviceId,
        'client': value.client,
    };
}


